import omit from 'lodash/object/omit';
import { removeProps } from 'styled-system';
import propTypes from './prop-types';

export default function (props) {
  return omit(removeProps(props), ['rules', ...Object.keys(propTypes)]);
}
